import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { Locale } from './locale.model';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DesignerComponent } from '../cp-designer/designer.component';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { LocaleElement } from './locale-element.model';

@Component({
  selector: 'app-locales',
  templateUrl: './locales.component.html',
  styleUrls: ['./locales.component.css'],
  providers: [DesignerComponent],
})
export class LocalesComponent extends SuperClass implements OnInit {
  locales: any;
  selectedRow: any;
  elementsList: any;
  selectedLocale;
  elementsNames = [];
  selectedLocalRow: any = {};
  display = false;
  displayNewLocale = false;
  selectedTab;
  displayCreateLit;
  newLocaleForm: FormGroup;

  newLocale;
  newLit;
  cpCodes;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Captive Portal' },
      {
        label: 'Language & Locales',
        routerLink: [{ outlets: { sub: [RouterConst.LOCALES] } }],
      },
    ]);
    this.newLocale = new Locale();
    this.newLit = new LocaleElement();
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData() {
    this.http_getAllLocales((data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.locales = data.payload;
      }
    });

    this.http_getAllCpCodes((data: any) => {
      this.cpCodes = data.payload;
    });

    this.newLocaleForm = this.fb.group({
      code: new FormControl('', Validators.required),
      locale: new FormControl('', Validators.required),
      lang: new FormControl('', Validators.required),
      desc: new FormControl('', Validators.required),
    });
  }

  ngOnInit() {
    this.reloadData();
  }

  selectRow(e) {
    this.selectedRow = e.data;
    this.http_getElements(
      {
        cpCode: this.selectedRow.cpCode,
        languageCode: this.selectedRow.languageCode,
      },
      (data: any) => {
        this.elementsNames = data.payload.titles;
        this.elementsList = data.payload.elements;
        //this.selectTab(Object.keys(this.elementsList)[0]);
        this.selectTab(this.selectedTab);
      },
    );
  }

  selectLocalRow(e) {
    this.display = true;
    this.selectedLocalRow = new Locale(e.data);
  }

  selectTab(e) {
    this.selectedLocale = this.elementsList[e];
    this.selectedTab = e;
  }

  editLocale() {
    this.http_updateElement(this.selectedLocalRow, (data: any) => {
      this.selectedLocale = data.payload.elements[this.selectedTab];
      this.showSuccessMessage('Locale has been updated');
      this.display = false;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }

  addNewLocale() {
    this.displayNewLocale = true;
  }

  updateFromFile(files: File) {
    const fileToUpload = files;
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload);
    formData.append('cpCode', this.selectedRow.cpCode);
    formData.append('cpLocaleCode', this.selectedRow.cpLocaleCode);
    formData.append('languageCode', this.selectedRow.languageCode);

    this.http_updateLocaleFromFile(formData, (data: any) => {
      this.locales = data.payload;
      this.showSuccessMessage('File has been successfully uploaded');
    });
  }

  createLocale() {
    const requiredFields = [
      {
        id: 'new_captivePortalCode',
        value: this.newLocale.cpCode,
        fieldName: 'CP code',
      },
      {
        id: 'new_localeCpCode',
        value: this.newLocale.cpLocaleCode,
        fieldName: 'CP Locale Code',
      },
      {
        id: 'new_languageCode',
        value: this.newLocale.languageCode,
        fieldName: 'Language Code',
      },
      {
        id: 'new_description',
        value: this.newLocale.description,
        fieldName: 'Description',
      },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_createNewLocale(
      {
        cpCode: this.newLocale.cpCode.cpCode,
        cpLocaleCode: this.newLocale.cpLocaleCode,
        languageCode: this.newLocale.languageCode,
        description: this.newLocale.description,
      },
      (data: any) => {
        this.unselectRow();
        this.showSuccessMessage('New Locale has been created');
        this.locales = data.payload;
        this.displayNewLocale = false;
      },
    );
  }

  chooseCpCode(e) {}

  updateFromFileClick() {
    document.getElementById('localeFile').click();
  }

  addNewLit() {
    this.displayCreateLit = true;
  }

  createNewLit() {
    this.http_createNewLiteral(this.newLit, () => {
      this.reloadData();
    });
    this.displayCreateLit = false;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/locales/locales.component.ts